import {
  SwitchChainError as EvmSwitchChainError,
  BaseError as ViemBaseError,
} from "viem"
import {
  ConnectorChainMismatchError as EvmConnectorChainMismatchError,
  BaseError as WagmiBaseError,
} from "wagmi"
import {
  ConnectorChainMismatchError,
  InternalWalletError,
  LedgerError,
  PolychainError,
  RequestExpiredError,
  SignatureError,
  SwitchChainError,
  UnknownRpcError,
  WalletRejectedError,
} from "./errors"
import { isInternalWalletError } from "./isInternalWalletError"
import { isLedgerError } from "./isLedgerError"
import { isRequestExpiredError } from "./isRequestExpiredError"
import { isUnknownRpcError } from "./isUnknownRpcError"
import { isUserRejectedRequestError } from "./isUserRejectedRequestError"
import { walk } from "./walk"

export function parseSignatureError(error: unknown): PolychainError {
  if (error instanceof PolychainError) {
    return error
  }

  if (!(error instanceof WagmiBaseError || error instanceof ViemBaseError)) {
    return new SignatureError(error as Error)
  }

  if (isUserRejectedRequestError(error)) {
    return new WalletRejectedError(error)
  }

  if (isLedgerError(error)) {
    return new LedgerError(error)
  }

  if (isRequestExpiredError(error)) {
    return new RequestExpiredError(error)
  }

  if (isInternalWalletError(error)) {
    return new InternalWalletError(error)
  }

  if (isUnknownRpcError(error)) {
    return new UnknownRpcError(error)
  }

  if (walk(error, e => e instanceof EvmConnectorChainMismatchError)) {
    return new ConnectorChainMismatchError(error)
  }

  if (walk(error, e => e instanceof EvmSwitchChainError)) {
    return new SwitchChainError(error)
  }

  return new SignatureError(error)
}
